module.exports = __webpack_public_path__ + "static/media/kw-left-bg.62e0b645.jpg";